<template>
    <base-section id="about-our-product">
        <base-section-heading
            color="grey lighten-2"
            icon="mdi-play"
            title="About our Product"
        />

        <v-container>
            <v-row>
                <v-col v-for="card in cards" :key="card.title" cols="12" md="4">
                    <base-info-card v-bind="card" />
                </v-col>
            </v-row>
        </v-container>
    </base-section>
</template>

<script>
export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
        cards: [
            {
                title: 'Run Anywhere',
                subtitle: 'Windows, Ubuntu, Android',
                text:
                    'Built for compatability to run on a range of platforms to simply slot into your current environment.',
                callout: '01'
            },
            {
                title: 'Easy Intergration',
                subtitle: 'Use it how you need it',
                text:
                    'With a web configuration console you can set it up how you need and with local remote commands, use it how you want.',
                callout: '02'
            },
            {
                title: 'Feature Requests',
                subtitle: 'We made this for you',
                text:
                    "We're open to advancing our frameworks. Contact us if you dont see what you need and we'll happily develop on the idea.",
                callout: '03'
            }
        ]
    })
};
</script>
